import React from 'react';
import { CopyIcon } from '../../assets/icons/Icons';
import "../../assets/scss/components/copyable-text.scss"

const CopyableInput = (props) => {

    const copyValue = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(props.text);
    }

    return (
        <span className="input-with-icon input-with-icon-right">
            <input value={props.text || '-'} type="text" name={props.name}/>
            {props.text && <span className="input-icon input-icon-right" onClick={copyValue}><CopyIcon/></span>}
        </span>
    );
};

export default CopyableInput;
